/**
 * @generated SignedSource<<5b26aed0369acd490a0b9febdea27379>>
 * @lightSyntaxTransform
 * @nogrep
 * @codegen-command: yarn relay
 */

/* tslint:disable */
/* eslint-disable */
// @ts-nocheck

import type { Fragment, ReaderFragment } from 'relay-runtime';
import type { FragmentRefs } from "relay-runtime";
export type card_fragment$data = {
  readonly fieldsById: {
    readonly edges: ReadonlyArray<{
      readonly node: {
        readonly fieldId: string;
        readonly id?: string;
        readonly issueType?: {
          readonly avatar: {
            readonly small: string | null | undefined;
          } | null | undefined;
          readonly name: string;
        } | null | undefined;
        readonly richText?: {
          readonly adfValue: {
            readonly convertedPlainText: {
              readonly plainText: string | null | undefined;
            } | null | undefined;
          } | null | undefined;
        } | null | undefined;
        readonly status?: {
          readonly name: string | null | undefined;
        };
      } | null | undefined;
    } | null | undefined> | null | undefined;
  } | null | undefined;
  readonly id: string;
  readonly key: string;
  readonly summary: string | null | undefined;
  readonly " $fragmentType": "card_fragment";
};
export type card_fragment$key = {
  readonly " $data"?: card_fragment$data;
  readonly " $fragmentSpreads": FragmentRefs<"card_fragment">;
};

const node: ReaderFragment = (function(){
var v0 = {
  "kind": "ScalarField",
  "name": "id"
},
v1 = {
  "kind": "ScalarField",
  "name": "name"
};
return {
  "argumentDefinitions": [],
  "kind": "Fragment",
  "name": "card_fragment",
  "selections": [
    (v0/*: any*/),
    {
      "kind": "ScalarField",
      "name": "key"
    },
    {
      "kind": "ScalarField",
      "name": "summary"
    },
    {
      "args": [
        {
          "kind": "Literal",
          "name": "ids",
          "value": [
            "issuetype",
            "status",
            "description"
          ]
        }
      ],
      "concreteType": "JiraIssueFieldConnection",
      "kind": "LinkedField",
      "name": "fieldsById",
      "plural": false,
      "selections": [
        {
          "concreteType": "JiraIssueFieldEdge",
          "kind": "LinkedField",
          "name": "edges",
          "plural": true,
          "selections": [
            {
              "kind": "LinkedField",
              "name": "node",
              "plural": false,
              "selections": [
                {
                  "kind": "ScalarField",
                  "name": "fieldId"
                },
                {
                  "kind": "InlineFragment",
                  "selections": [
                    {
                      "concreteType": "JiraIssueType",
                      "kind": "LinkedField",
                      "name": "issueType",
                      "plural": false,
                      "selections": [
                        (v1/*: any*/),
                        {
                          "concreteType": "JiraAvatar",
                          "kind": "LinkedField",
                          "name": "avatar",
                          "plural": false,
                          "selections": [
                            {
                              "kind": "ScalarField",
                              "name": "small"
                            }
                          ]
                        }
                      ]
                    }
                  ],
                  "type": "JiraIssueTypeField"
                },
                {
                  "kind": "InlineFragment",
                  "selections": [
                    (v0/*: any*/),
                    {
                      "concreteType": "JiraStatus",
                      "kind": "LinkedField",
                      "name": "status",
                      "plural": false,
                      "selections": [
                        (v1/*: any*/)
                      ]
                    }
                  ],
                  "type": "JiraStatusField"
                },
                {
                  "kind": "InlineFragment",
                  "selections": [
                    {
                      "concreteType": "JiraRichText",
                      "kind": "LinkedField",
                      "name": "richText",
                      "plural": false,
                      "selections": [
                        {
                          "concreteType": "JiraADF",
                          "kind": "LinkedField",
                          "name": "adfValue",
                          "plural": false,
                          "selections": [
                            {
                              "concreteType": "JiraAdfToConvertedPlainText",
                              "kind": "LinkedField",
                              "name": "convertedPlainText",
                              "plural": false,
                              "selections": [
                                {
                                  "kind": "ScalarField",
                                  "name": "plainText"
                                }
                              ]
                            }
                          ]
                        }
                      ]
                    }
                  ],
                  "type": "JiraRichTextField"
                }
              ]
            }
          ]
        }
      ],
      "storageKey": "fieldsById(ids:[\"issuetype\",\"status\",\"description\"])"
    }
  ],
  "type": "JiraIssue"
};
})();

(node as any).hash = "322eefb2447626d447467304ee0e2a9b";

export default node;
